import { toast } from "react-toastify";
import AuthService from "./AuthServices";

/**
 * @file All Apis Services.
 * @author Fatih Arıcılık
 */

//MD5 and Axiost Import -_-
var md5 = require("md5");
var axios = require("axios");

/**
 * Login APIs
 * @param {*} param0
 * @returns TOKEN path ./AuthServices
 */
// export function login({ username, password }) {
//   return axios.post(process.env.REACT_APP_API_TOKEN_URL + "/api/user/SignIn", {
//     UserName: username,
//     Password: md5(password),
//   });
// }

//roboliza v5 için
export function login({ username, password }) {
  return axios.get(`${process.env.REACT_APP_API_TOKEN_URL}/Auth/LoginCustomer?Username=${username}&Password=${password}`);
}

export function loginVerify({ Guid, VerifyKey }) {
  return axios.get(`${process.env.REACT_APP_API_TOKEN_URL}/Auth/LoginVerify?Guid=${Guid}&VerifyKey=${VerifyKey}`);
}


/**
 * Post Answers List
 * @param {string} value - Survey ID
 * @returns 200 or 400-401-500
 */
export function postAnswers(value) {
  return axios.post(process.env.REACT_APP_API_URL + "/api/answers", value);
}

/**
 * Get Always Surveys
 * @returns All Survey
 */
export function getSurveys() {
  return axios.get(process.env.REACT_APP_API_URL + "/api/surveys", AuthService());
}

/**
 *  Get ID params Survey
 * @param {string} value - Survey ID
 * @returns Survey
 */
export function getSurvey(value) {
  return axios.get(process.env.REACT_APP_API_URL + "/api/survey/" + value);
}

/**
 * Get ID params Survey
 * @param {string} value - Survey ID
 * @returns Analys Datas
 */
export function getAnalysis(value, startDate, endDate) {
  // URL oluşturulurken startDate ve endDate'yi sorgu parametreleri olarak ekliyoruz
  const params = new URLSearchParams();
  
  if (startDate) {
    params.append('startDate', startDate);
  }
  
  if (endDate) {
    params.append('endDate', endDate);
  }

  return axios.get(`${process.env.REACT_APP_API_URL}/api/analysis/${value}`, {
    params: params,
    ...AuthService(),
  });
}

// export function getAnalysis(value) {
//   return axios.get(process.env.REACT_APP_API_URL + "/api/analysis/" + value, AuthService());
// }

/**
 * Post Fınısh Survey Thema
 * @param {string} value - Survey ID
 * @returns Fınısh Survey Thema
 */
export function postSurvey(value) {
  const formData = new FormData();

  // JSON verisini FormData'ya ekleyelim
  formData.append('title', value.title);
  formData.append('description', value.description);
  formData.append('questions', JSON.stringify(value.questions));
  //formData.append('user_id', value.user_id);

  //console.log("userid:",value);

  if (value.headerBackground) {
    formData.append('headerBackground', value.headerBackground);
  }
  if (value.footerBackground) {
    formData.append('footerBackground', value.footerBackground);
  }
  console.log("valuePostSurvey",value);
  
  if (value?.questions && Array.isArray(value.questions)) {
    value.questions.forEach((question) => {
      if (question?.emoji == true) {
        // firstEmojiUrl veya secondEmojiUrl parametreleri varsa, hata fırlat
        if (!question.firstEmojiUrl || !question.secondEmojiUrl) {
          toast.error("Emojileri yüklediğinize emin olun.")
          console.log("valuequestions", question);
          throw new Error("ERR_UPLOAD_EMOJI");
        }
      }
    });
  }
  
  

  // Diğer form alanlarını ekleyebilirsiniz, örneğin:
  // formData.append('otherField', value.otherField);

  // Axios ile gönderim
  return axios.post(process.env.REACT_APP_API_URL + "/api/survey", formData, AuthService());
}

export function postEmoji(value) {
  const formData = new FormData();

  if (value) {
    formData.append('firstEmoji', value);
  }

  return axios.post(process.env.REACT_APP_API_URL + "/api/emoji", formData, AuthService());
}

export function getPagesImageStore({ page }) {
  return axios.get(
    process.env.REACT_APP_API_URL + "/api/image-store?page="+page+"&limit=10",
    AuthService()
  );
}

/**
 * Get Pagenation count
 * @param {string} value  - Survey ID
 * @returns - page count
 */

export function getPageCount(value) {
  return axios.get(
    process.env.REACT_APP_API_URL + "/api/answers/" + value + "/count",
    AuthService()
  );
}

/**
 * Get Pages Answes
 * @param {string} SurveyID - Surveys ID
 * @param {int} page - Openned pages
 * @returns - Surveys
 */

export function getPagesAnswers({ SurveyID, page }) {
  return axios.get(
    process.env.REACT_APP_API_URL + "/api/answers/" + SurveyID + "?page=" + page,
    AuthService()
  );
}

/**
 *
 * @param {string} value - Surveys ID
 * @returns 200.400 or ..
 */
export function deleteSurvey(value) {
  return axios.delete(process.env.REACT_APP_API_URL + "/api/survey/" + value, AuthService());
}

/**
 *
 * @param {json} value - Surver List
 * @returns - 200,400,404 ...
 */
export function editSurvey({ id, value }) {
  const formData = new FormData();

  // JSON verisini FormData'ya ekleyelim
  formData.append('title', value.title);
  formData.append('description', value.description);
  formData.append('questions', JSON.stringify(value.questions));
  formData.append('user_id', value.user_id);

  if (value.headerBackground) {
    formData.append('headerBackground', value.headerBackground);
  }
  if (value.footerBackground) {
    formData.append('footerBackground', value.footerBackground);
  }
  return axios.put(process.env.REACT_APP_API_URL + "/api/survey/" + id, formData, AuthService());
}
